import { Select } from "components";
import { pixelPerInch } from "constants/appConstant";
import React, { useMemo, useState, useRef, useEffect } from "react";
import { useQuery } from "react-query";
import {
  getAccessorieCategories,
  getAccessorieRails,
  getAccessories,
} from "services/headwallServices";
import { useHeadWallStore, useLoaderStore } from "store";

const mountType = [
  { label: "Direct", value: "direct" },
  { label: "Rail", value: "rail" },
  { label: "Track", value: "track" },
];

function Accessories({ handleDragStart }) {
  const [accessories, setAccessories] = useState([]);
  const [accessorieRails, setAccessorieRails] = useState([]);
  const [accessorieCategories, setAccessorieCategories] = useState([]);
  const [mount, setMount] = useState("direct");
  const [category, setCategory] = useState("");
  const { setLoading } = useLoaderStore();

  const { values } = useHeadWallStore();
  const { model } = values;

  useQuery({
    queryKey: ["accessorie_category"],
    queryFn: () => getAccessorieCategories(),
    refetchOnWindowFocus: false,
    onSuccess: (data) => {
      const res = data.data.data;
      const categories = res?.map((c) => {
        return { label: c.name, value: c._id };
      });
      setAccessorieCategories(categories);
      setCategory(res[0]?._id);
    },
  });
  //fetch accessories
  const { isLoading } = useQuery({
    queryKey: [`accessories_${mount}_${category}`],
    queryFn: () => getAccessories(mount, category),
    refetchOnWindowFocus: false,
    enabled: !!category,
    onSuccess: (data) => {
      setAccessories(data?.data?.data);
    },
  });

  // //fetch accessorie rails
  useQuery({
    queryKey: [`accessorie_rails_${model}`],
    queryFn: () => getAccessorieRails(model),
    refetchOnWindowFocus: false,
    onSuccess: (data) => {
      let res = data?.data?.data;
      res.forEach((item) => {
        item.accessories = [];
      });
      setAccessorieRails(res);
    },
  });

  //manage loader
  useMemo(() => {
    setLoading(isLoading);
  }, [isLoading, setLoading]);

  const categoriseAccessories = useMemo(() => {
    let accObj = {};
    accObj["largeAccessories"] = accessories?.filter((serv) => serv.width >= 5);
    accObj["smallAccessories"] = accessories?.filter((serv) => serv.width < 5);
    return accObj;
  }, [accessories]);

  return (
    <>
      <div className="pt-4 mt-8 border-t-2 border-slate-300">
        <div className="overflow-auto accessories_panel_height">
          <p className="font-bold text-base txtBlue headingTxt">Rail Type</p>
          <div className="grid gap-4 grid-cols-2 my-2 ">
            {accessorieRails.map((acc, i) => (
              <div
                style={{ display: "grid", gridTemplateRows: "auto 88px" }}
                key={i}
              >
                <div className="font-normal text-sm py-2 txtBlue">
                  {acc.name}
                </div>
                <div className="servicesListItem bg-white rounded border border-slate-300 flex flex-col items-center p-4 justify-center  relative">
                  <div
                    draggable={true}
                    onDragStart={(e) => {
                      handleDragStart(acc, e);
                    }}
                    className="flex justify-center hover:z-50 items-center"
                    style={{
                      cursor: "grab",
                    }}
                  >
                    <div
                      style={{
                        width: acc.width / pixelPerInch,
                        backgroundImage: `url(${acc.image_url})`,
                        backgroundSize: "cover",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center",
                        userSelect: "none",
                        height: acc.height / pixelPerInch,
                      }}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="pt-4 mt-8 border-t-2 border-slate-300">
            <p className="font-semibold text-base txtBlue">Category</p>
            <div className="my-2">
              <Select
                name="category"
                className="bg-white rounded-r font-bold text-xs w-full p-2 rounded border border-slate-300"
                options={accessorieCategories}
                value={category}
                handleSelect={(e) => setCategory(e.target.value)}
              />
            </div>
          </div>
          <div>
            <p className="font-semibold text-base txtBlue">Mount Type</p>
            <div className="my-2">
              <Select
                name="mount_type"
                className="bg-white rounded-r font-bold text-xs w-full p-2 rounded border border-slate-300"
                options={mountType}
                value={mount}
                handleSelect={(e) => setMount(e.target.value)}
              />
            </div>
          </div>
          <div className="pt-4 mt-8 border-t-2 border-slate-300">
            <p className="font-bold text-base txtBlue headingTxt">
              Accessories
            </p>
            {!!categoriseAccessories.largeAccessories.length && (
              <div className="grid gap-4 grid-cols-1 my-2 ">
                {categoriseAccessories.largeAccessories.map((acc, i) => (
                  <AccessoriesList
                    item={acc}
                    handleDragStart={handleDragStart}
                    key={i}
                  />
                ))}
              </div>
            )}
            {!!categoriseAccessories.smallAccessories.length && (
              <div className="grid gap-4 grid-cols-2 my-2 ">
                {categoriseAccessories.smallAccessories.map((acc, i) => (
                  <AccessoriesList
                    item={acc}
                    handleDragStart={handleDragStart}
                    key={i}
                  />
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
export default Accessories;

const AccessoriesList = (props) => {
  const img = useMemo(() => new Image(), []);
  const sourceRef = useRef(null);
  const { item, handleDragStart } = props;

  useEffect(() => {
    const loadImage = async () => {
      const width = item.width / pixelPerInch;
      const height = item.height / pixelPerInch;

      try {
        const resp = await fetch(item.image);
        const blob = await resp.blob();
        const bmp = await createImageBitmap(blob, {
          resizeWidth: width,
          resizeHeight: height,
        });

        const canvas = Object.assign(document.createElement("canvas"), {
          width,
          height,
        });
        canvas.getContext("2d").drawImage(bmp, 0, 0);

        await new Promise((resolve) => {
          canvas.toBlob((blob) => {
            img.src = URL.createObjectURL(blob);
            resolve(img.decode());
          });
        });

        // Add drag handlers after loading the image
      } catch (error) {
        console.error("Error loading image:", error);
      }
    };

    loadImage();
  }, [item, img]); // ✅ Add imageUrl as a dependency
  return (
    <div
      className="servicesListItem bg-white rounded border border-slate-300 p-4 justify-between relative" //flex flex-col items-center
      key={item._id}
    >
      <div
        className="flex justify-center hover:z-50 items-center"
        style={{
          cursor: "grab",
        }}
      >
        <div
          id="source"
          ref={sourceRef}
          draggable={true}
          onDragStart={(e) => {
            handleDragStart(item, e, img);
          }}
          style={{
            width: item.width / pixelPerInch,
            height: item.height / pixelPerInch,
            backgroundImage: `url(${item.image})`,
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            userSelect: "none", 
          }}
        />
      </div>
      <p
        className="font-medium text-xs my-2 text-center"
        style={{ wordBreak: "break-word" }}
      >
        {item.name}
      </p>
    </div>
  );
};
